// Display only. Full Shopify original bundle price minus full native app payable; no price/plan/cart writes.
function splitMoney(text) {
  const source = String(text ?? '').trim();
  const match = source.match(/\d(?:[\d.,'’\s\u00a0\u202f]*\d)?/);
  if (!match || /\d/.test(source.slice(match.index + match[0].length))) return null;
  const prefix = source.slice(0, match.index), suffix = source.slice(match.index + match[0].length);
  if (/[-−–+]/.test(prefix + suffix)) return null;
  return {prefix, suffix, number: match[0]};
}

export function savingAmount(originalPrice, subscription, sample) {
  const format = splitMoney(sample), a = splitMoney(originalPrice), b = splitMoney(subscription);
  if (!format || !a || !b) return null;
  // The Liquid sample is 123456789 minor units: fractional digits are 89,
  // or absent for Shopify's zero-decimal presentation. Unknown formats fail closed.
  const decimal = format.number.match(/([.,])89$/)?.[1] || '';
  const whole = decimal ? format.number.slice(0, -3) : format.number;
  const group = whole.match(/[^\d]/)?.[0] || '';
  if (whole.replace(/\D/g, '') !== (decimal ? '1234567' : '1234568')) return null;
  const normalize = s => s.replace(/[\s\u00a0\u202f]/g, '');
  const parse = parts => {
    if (normalize(parts.prefix) !== normalize(format.prefix) || normalize(parts.suffix) !== normalize(format.suffix)) return null;
    let integer = parts.number, fraction = '';
    if (decimal) {
      if (integer.slice(-3, -2) !== decimal || !/^\d{2}$/.test(integer.slice(-2))) return null;
      fraction = integer.slice(-2); integer = integer.slice(0, -3);
    }
    const groups = group ? integer.split(group) : [integer];
    if (!groups.every(s => /^\d+$/.test(s))) return null;
    if (groups.length > 1 && (groups[0].length > 3 || groups.slice(1).some(s => s.length !== 3))) return null;
    const value = Number(groups.join('')) * 100 + Number(fraction);
    return Number.isSafeInteger(value) && value >= 0 ? value : null;
  };
  const original = parse(a), reduced = parse(b);
  if (original === null || reduced === null || reduced >= original) return null;
  const saved = original - reduced;
  let integer = String(Math.floor(saved / 100));
  if (group) integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, group);
  return format.prefix + integer + (decimal ? decimal + String(saved % 100).padStart(2, '0') : '') + format.suffix;
}

if (typeof customElements !== 'undefined' && !customElements.get('ark-subscription-savings')) {
  customElements.define('ark-subscription-savings', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.content = this.closest('.main-product__content');
      this.row = this.closest('[data-ark-savings-row]');
      if (!this.content || !this.row) return;
      try { this.originalPrices = JSON.parse(this.dataset.originalPrices || '{}'); }
      catch { this.originalPrices = {}; }
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.isConnected) this.sync();
        });
      };
      this.observer = new MutationObserver(records => {
        if (records.some(record => {
          const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          if (target?.closest('.ark-unit-price-line')) return false;
          if (target?.closest('kaching-subscriptions-block')) return true;
          return record.type === 'childList' && [...record.addedNodes, ...record.removedNodes].some(node =>
            node.nodeType === 1 && (node.matches('kaching-subscriptions-block') || node.querySelector('kaching-subscriptions-block')));
        })) this.schedule();
      });
      this.observe();
      this.content.addEventListener('change', this.schedule, true);
      this.content.addEventListener('variant:change', this.schedule, true);
      this.schedule();
    }
    observe() {
      this.observer.observe(this.content, {subtree:true, childList:true, characterData:true, attributes:true,
        attributeFilter:['current-variant-id','quantity','class']});
    }
    sync() {
      const widget = this.content.querySelector('kaching-subscriptions-block');
      const checked = this.content.querySelector('product-tiers input[data-variant-id]:checked');
      const sameVariant = widget && checked && widget.getAttribute('current-variant-id') === checked.dataset.variantId;
      const oneTime = widget?.querySelector('.one-time-purchase .kaching-subscriptions__card-info.selected');
      const regular = checked && this.originalPrices?.[checked.dataset.variantId];
      const discounted = widget?.querySelector('.ks-panel.selected .ks-discounted-price')?.textContent
        || widget?.querySelector('.ks-discounted-price')?.textContent;
      const value = sameVariant && !oneTime ? savingAmount(regular, discounted, this.dataset.moneySample) : null;
      this.observer.disconnect();
      try {
        if (value && this.textContent !== value) this.textContent = value;
        if (!value && this.textContent) this.textContent = '';
        if (value && this.row.style.display === 'none') this.row.style.removeProperty('display');
        if (!value && this.row.style.display !== 'none') this.row.style.display = 'none';
      } finally { if (this.isConnected) this.observe(); }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.content?.removeEventListener('change', this.schedule, true);
      this.content?.removeEventListener('variant:change', this.schedule, true);
      if (this.row) this.row.style.display = 'none';
      this.observer = null;
    }
  });
}
